import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://store.buzzybrains.net/api';

console.log('API_BASE_URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    console.log('Full URL:', `${config.baseURL}${config.url}`);
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('API Error:', error);
    console.error('Error config:', error.config);
    console.error('Error response:', error.response);
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  getCurrentUser: () => api.get('/auth/me'),
};

// Admin API
export const adminAPI = {
  // Statistics
  getStats: () => api.get('/admin/stats'),

  // Analytics
  getAnalyticsSummary: (params) => api.get('/admin/analytics/summary', { params }),
  getActivityBreakdown: (params) => api.get('/admin/analytics/activities', { params }),
  getActivityLogs: (params) => api.get('/admin/analytics/activity-logs', { params }),

  // Users
  getUsers: (params) => api.get('/admin/users', { params }),
  getUser: (userId) => api.get(`/admin/users/${userId}`),
  createUser: (data) => api.post('/auth/register', data),
  updateUser: (userId, data) => api.put(`/admin/users/${userId}`, data),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),

  // Bulk Upload
  downloadCSVTemplate: () => api.get('/admin/users/csv-template', {
    responseType: 'blob'
  }),
  downloadExcelTemplate: () => api.get('/admin/users/excel-template', {
    responseType: 'blob'
  }),
  bulkUploadUsers: (formData) => api.post('/admin/users/bulk-upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),

  // Forms
  getHBNCForms: (params) => api.get('/admin/forms/hbnc', { params }),
  getHBNCForm: (formId) => api.get(`/forms/hbnc/${formId}`),
  getHBYCForms: (params) => api.get('/admin/forms/hbyc', { params }),
  getHBYCForm: (formId) => api.get(`/forms/hbyc/${formId}`),
  getNRCForms: (params) => api.get('/admin/forms/nrc', { params }),
  getNRCForm: (formId) => api.get(`/forms/nrc/${formId}`),
  getSNCUForms: (params) => api.get('/admin/forms/sncu', { params }),
  getSNCUForm: (formId) => api.get(`/forms/sncu/${formId}`),
};

// Location API
export const locationAPI = {
  // Districts
  getDistricts: () => api.get('/locations/districts'),
  getDistrict: (districtId) => api.get(`/locations/districts/${districtId}`),
  createDistrict: (data) => api.post('/locations/districts', data),
  updateDistrict: (districtId, data) => api.put(`/locations/districts/${districtId}`, data),
  deleteDistrict: (districtId) => api.delete(`/locations/districts/${districtId}`),

  // Talukas
  getTalukas: (params) => api.get('/locations/talukas', { params }),
  getTaluka: (talukaId) => api.get(`/locations/talukas/${talukaId}`),
  createTaluka: (data) => api.post('/locations/talukas', data),
  updateTaluka: (talukaId, data) => api.put(`/locations/talukas/${talukaId}`, data),
  deleteTaluka: (talukaId) => api.delete(`/locations/talukas/${talukaId}`),
};

// RAG Chatbot API
export const ragAPI = {
  query: (query, model = null) => api.post('/rag/query', { query, ...(model && { model }) }),
};

// Knowledge Base API
export const knowledgeBaseAPI = {
  getFiles: (language) => api.get('/admin/knowledge-base/files', { params: { language } }),
  uploadFile: (formData) => api.post('/admin/knowledge-base/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }),
  downloadFile: (fileId) => api.get(`/admin/knowledge-base/files/${fileId}/download`),
  deleteFile: (fileId) => api.delete(`/admin/knowledge-base/files/${fileId}`),
  reembedFile: (fileId) => api.post(`/admin/knowledge-base/files/${fileId}/reembed`),
  rebuildAll: (language) => api.post(`/admin/knowledge-base/rebuild/${language}`),
  getRebuildStatus: (commandId) => api.get(`/admin/knowledge-base/rebuild/status/${commandId}`),
};

export default api;
